import * as React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Text, Image, View, Link } from "@react-pdf/renderer";
import { times } from "lodash";
import tdcTile from "../../../assets/pdf-export/bot-tile.png";
import { styles } from "./styles";

export const PageFooter: React.FC = () => (
  <View style={styles.bottomSection} fixed>
    <View style={styles.bottomTile}>
      {times(8, (i) => (
        <Image style={styles.tileItem} source={tdcTile} key={i} />
      ))}
    </View>
    <View style={styles.bottomTextWrapper}>
      <Text style={styles.bottomText1}>Contact us at:</Text>
      <Link src="mailto:sales@thedesirecompany.com">
        <Text style={styles.bottomText2}>SALES@THEDESIRECOMPANY.COM</Text>
      </Link>
    </View>
  </View>
);
